/**
 * 补打卡异常数据单页信息
 */
import './repairClockIn.less';

import React, { Component } from 'react';
import { Container } from 'flux/utils';

import { getItem as getLang } from '../../common/lang';

import Header from '../../components/Header/Header.jsx';
import InfoCard from '../../components/InfoCard/InfoCard.jsx';
import Loader from '../../components/Loader/Loader.jsx';
import ConfirmButton from '../../components/ConfirmButton/ConfirmButton.jsx';
import FormControl from '../../components/FormControl/FormControl.jsx';
import TextInput from '../../components/TextInput/TextInput.jsx';
import ErrorBox from '../../components/Alert/ErrorBox.jsx';

import RepairClockInStore from '../../stores/RepairClockInStore';
import RepairClockInDataUtils from '../../data-utils/RepairClockInDataUtils';

class RepairClockInEmpCheckRecord extends Component {
    static getStores() {
		return [RepairClockInStore];
	}

	static calculateState() {
		return RepairClockInStore.getState();
	}
    constructor(props){
        super(props);
        this.commitApply = this.commitApply.bind(this);
        var id = this.props.routeParams.id;
        RepairClockInDataUtils.getEmpRciExDetail(id);
    }
    render(){
        const {
            record = {
                names: [],
                rows: []
            },
            status = 'loading'
        } = this.state;

       let info = {
                'title': '单据信息',
                'items': []
       };

       record.names.map((item, index) => {
            info.items.push({
                firField: item,
                secField: record.values[index]
            });
       });

       return (<div><Header goBack title='核算数据（异常）' />
                <Loader status={status} ></Loader>
                <div><h2 className="info-card-heading gap-b">{info.title}</h2>
					<InfoCard items={info.items} />
				</div>
                <div>
                    <textarea placeholder="原因 / 备注" className='input-rci-reason' ref='txtReason' />
                    <ErrorBox ref='errorBox' />
                    <ConfirmButton text={getLang('COMMIT_APPLY')} onTouchTap={this.commitApply} />
				</div>
      </div>);
    }

    /**
     * 提交申请
     */
    commitApply() {
        let $reason = React.findDOMNode(this.refs.txtReason);

        if($reason.value == ''){
            this.refs.errorBox.setState({message:'请输入原因或备注'});
            return;
        }else{
            //提交申请并跳转
            //alert('执行跳转');
            //window.location.hash = '#/my-rci/';
        }
        
		// OvertimeDataUtils.revokeRecord({
		// 	id: this.props.routeParams.id,
		// 	onRevoke: this.state.empOtRecord.onRevoke
		// });
	}
}

export default Container.create(RepairClockInEmpCheckRecord);



// WEBPACK FOOTER //
// ./src/containers/RepairClockIn/RepairClockInEmpCheckRecordContainer.js